<template>
  <CardsSection collapse :title="title" :items-length="totalCards" :transition-duration="500">
    <template #header>
      <AppCounter v-if="totalCards > 0" :total="totalCards" />
    </template>
    <div class="transition-group">
      <!-- pack cards -->
      <CardsSectionClientActivesPack />
      <!-- individuals cards -->
      <!-- <CardsSectionClientActivesIndividuals /> -->
    </div>
  </CardsSection>
</template>

<script>
// Utilities
import { mapState } from 'vuex'
// Components
import AppCounter from 'Ui/AppCounter'
import CardsSection from 'Components/CardsSection'
import CardsSectionClientActivesPack from 'Components/CardsSectionClientActivesPack'
// import CardsSectionClientActivesIndividuals from 'Components/CardsSectionClientActivesIndividuals'

export default {
  name: 'CardsSectionClient',

  components: {
    AppCounter,
    CardsSection,
    CardsSectionClientActivesPack,
    // CardsSectionClientActivesIndividuals,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState('client', ['cards']),
    totalCards() {
      return this.cards.filter((card) => card.status === 'active').length
    },
  },
}
</script>

<style scoped>
.single-cards {
  margin-top: 50px;
}
</style>
